var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0025 11.3231C30.0035 11.6219 29.9376 11.9171 29.8095 12.187C29.6815 12.457 29.4945 12.6948 29.2625 12.8831L17.2625 22.5431C16.9046 22.8372 16.4558 22.998 15.9925 22.998C15.5293 22.998 15.0804 22.8372 14.7225 22.5431L2.7225 12.5431C2.31407 12.2036 2.05722 11.7158 2.00846 11.1869C1.9597 10.6581 2.12303 10.1315 2.4625 9.72307C2.80198 9.31464 3.2898 9.05779 3.81866 9.00903C4.34751 8.96027 4.87407 9.12359 5.2825 9.46307L16.0025 18.4031L26.7225 9.76307C27.0161 9.5185 27.3736 9.36315 27.7527 9.31539C28.1317 9.26763 28.5166 9.32946 28.8617 9.49358C29.2067 9.65769 29.4975 9.91721 29.6997 10.2414C29.9019 10.5656 30.007 10.941 30.0025 11.3231Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretdown);
export default __webpack_public_path__ + "static/media/caretdown.aca61482b830fa8208dd77a17580d8d9.svg";
export { ForwardRef as ReactComponent };